// Wrapper to safely handle Supabase client initialization.
// IMPORTANT: this must reuse the generated client whenever it exists, otherwise
// two GoTrue clients fight over the same storage key and the session (and the
// user's organization) never resolves in some environments.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { supabase as generatedClient } from './client';

// Lovable Cloud - Supabase credentials (public values, safe to include)
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://zxkekzhreygcfyfqkkqp.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp4a2VremhyZXlnY2Z5ZnFra3FwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIzMDAyNDMsImV4cCI6MjA3Nzg3NjI0M30.4MgunLleeubxikU1HSOwADvrFb8e7QAdhiDAlsLyU3A';

// Fallback client only created when env vars are missing and the generated
// client could not be created (creating it eagerly would spawn a second
// auth client).
const createFallbackClient = () =>
  createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    },
  });

export const supabase = generatedClient ?? createFallbackClient();

// Helper to check if Supabase is available
export const isSupabaseAvailable = () => !!supabase;
